import axios from 'axios';
import connection from './connection';
import { AllInterviewResponseModel, InterviewDto, InterviewResponseModel} from '@gtpl/shared-models/hrms';

export class InterviewService{

    URL = connection.DEPLOY_URL + '/interview';

    async createinterview(InterviewDto: InterviewDto ): Promise<InterviewResponseModel> {
        console.log(InterviewDto);
       
        return await axios.post(this.URL + '/createinterview',InterviewDto)
            .then(res => {
                return res.data
            })
    }

    async getAllInterview(): Promise<AllInterviewResponseModel> {
                
        return await axios.post(this.URL + '/getAllInterview')
            .then(res => {
                return res.data 
            })     
    }

    async  updateInterview(InterviewDto: InterviewDto): Promise<InterviewResponseModel> {
        return await axios.post(this.URL + '/updateinterview', InterviewDto)
                        .then(res => {
                            return res.data
                        })
                }
    
    async  activateOrDeactivateInterview(InterviewDto: InterviewDto): Promise<InterviewResponseModel> {
        //   console.log(State.stateCode);
        return await axios.post(this.URL + '/activateOrDeactivateinterview', InterviewDto)
                        .then(res => {
                                return res.data
                        })
                }
    async getInterviewNameByInterviewIds(interviewReq: number[]): Promise<AllInterviewResponseModel> {
                    return await axios.post(this.URL + '/getInterviewNameByInterviewIds',interviewReq)
                        .then(res => {
                            return res.data
                        })     
                  }
                
}